<template>
  <div :class="$style.frameParent">
    <div :class="$style.frameGroup">
      <h2>{{ title }}</h2>
      <div :class="$style.frameContainer">
        <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
          <div :class="$style.formGroup">
            <div>Company Name</div>
            <input
              type="text"
              v-model="form.companyName"
              placeholder="Name..."
            />
          </div>
          <div :class="$style.formGroup">
            <div>Business Type</div>
            <HiloSelect
              :theme="'grey'"
              v-model="form.businessType"
              :options="[
                { id: true, name: 'Yes' },
                { id: false, name: 'No' },
              ]"
              :placeholder="'Choose one...'"
              :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
            />
          </div>
        </div>

        <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
          <div :class="$style.formGroup">
            <div>Email</div>
            <input type="email" v-model="form.email" placeholder="Email..." />
          </div>
          <div :class="$style.formGroup">
            <div>Phone</div>
            <input
              type="text"
              v-model="form.phoneNumber"
              placeholder="Phone Number..."
            />
          </div>
        </div>

        <div :class="$style.formGroup">
          <div>Website URL</div>
          <input
            type="text"
            v-model="form.websiteUrl"
            placeholder="Type your answer..."
          />
        </div>

        <div :class="$style.formGroup">
          <div>What is the business address?</div>
          <div :class="$style.formGroup">
            <input
              type="text"
              v-model="form.streetAddress"
              placeholder="Street Address..."
            />
          </div>
        </div>
        <div :class="$style.flexGroupAddress" :style="$global.dynamicCols(2)">
          <div :class="$style.formGroup">
            <input
              type="text"
              v-model="form.apartment"
              placeholder="Apt. or Suite..."
            />
          </div>
          <div :class="$style.formGroup">
            <input type="text" v-model="form.city" placeholder="City..." />
          </div>
        </div>
        <div :class="$style.flexGroupAddress" :style="$global.dynamicCols(3)">
          <div :class="$style.formGroup">
            <input type="text" v-model="form.state" placeholder="State..." />
          </div>
          <div :class="$style.formGroup">
            <input type="text" v-model="form.zip" placeholder="Zip..." />
          </div>
          <div :class="$style.formGroup">
            <input
              type="text"
              v-model="form.country"
              placeholder="Country..."
            />
          </div>
        </div>

        <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
          <div :class="$style.formGroup">
            <div>FAA AME Number</div>
            <input
              type="number"
              v-model="form.faaAmeNumber"
              placeholder="Type your answer..."
            />
          </div>
          <div :class="$style.formGroup">
            <div>Expiration Date</div>
            <input
              type="date"
              v-model="form.expirationDate"
              placeholder="Choose date..."
            />
          </div>
        </div>

        <div :class="$style.formGroup">
          <div>FAA region assigned</div>
          <input
            type="number"
            v-model="form.faaRegion"
            placeholder="Type your answer..."
          />
        </div>

        <div :class="$style.formGroup">
          <div>Current AME designation level:</div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.ameDesignation"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Select all that apply...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.formGroup">
          <div>
            Have you ever been involved in FAA enforcement actions related to
            medical certifications? (Optional):
          </div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.faaEnforcementActions"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Select all that apply...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.formGroup">
          <div>
            Would you like to connect with pilots or flight schools for more
            referrals?
          </div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.referrals"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Choose one...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.spaceBetween">
          <div :class="$style.formGroup">
            <div>Upload a copy of your FAA AME certificate.</div>
          </div>
          <div :class="$style.formGroup">
            <button :class="$style.uploadBtn">Upload</button>
          </div>
        </div>

        <div :class="$style.spaceBetween">
          <div :class="$style.formGroup">
            <div>Upload a copy of your state medical license.</div>
          </div>
          <div :class="$style.formGroup">
            <button :class="$style.uploadBtn">Upload</button>
          </div>
        </div>

        <div :class="$style.buttonContainer">
          <div
            :class="$style.nextButton"
            @click="$emit('onNext', { aboutYou: form })"
          >
            <b :class="$style.name">Next</b>
          </div>
          <div :class="$style.backButton" @click="$emit('onPrev')">
            <b :class="$style.name">Back</b>
          </div>
        </div>
      </div>
      <div :class="$style.frameChild4" />
    </div>
    <div :class="$style.frameChild5" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  components: {
    HiloSelect,
  },
  data() {
    return {
      form: {
        companyName: "",
        businessType: "",
        email: "",
        phoneNumber: "",
        websiteUrl: "",
        streetAddress: "",
        city: "",
        apartment: "",
        state: "",
        zip: "",
        country: "",
        faaAmeNumber: "",
        expirationDate: "",
        faaRegion: "",
        ameDesignation: "",
        faaEnforcementActions: "",
        referrals: "",
      },
    };
  },
});
</script>

<style module scoped>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
.frameGroup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.uploadBtn {
  width: fit-content;
  align-items: end;
}

.flexGroup {
  display: grid;
  gap: 10px;
}

.flexGroupAddress {
  display: grid;
  gap: 10px;
  margin-top: -15px;
}

.spaceBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.formGroup {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.formGroup p {
  font-size: 16px;
}

.frameContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
</style>
